import dayjs, { Dayjs } from 'dayjs'
import { StateCreator } from 'zustand'
import { WorkforceSharedSlice } from '../slice'

export type ApprovalsFilter = {
  requestType: string | null
  role: string | null
  staff: string | null
  status: string | null
  requestsFrom: Dayjs
  requestsTo: Dayjs
}
interface ApprovalsState {
  approvalsFilters: ApprovalsFilter
}

export interface ApprovalsSlice extends ApprovalsState {
  /**
   * Set the approvals page filters
   * @param filters the filters to set
   */
  setApprovalsFilter: (filters: ApprovalsFilter) => void
}

const initialState: ApprovalsState = {
  approvalsFilters: {
    requestType: null,
    role: null,
    staff: null,
    status: null,
    requestsFrom: dayjs().subtract(1, 'month').startOf('day'),
    requestsTo: dayjs().endOf('day'),
  },
}

const createApprovalsSlice: StateCreator<
  ApprovalsSlice & WorkforceSharedSlice,
  [],
  [],
  ApprovalsSlice
> = (set) => ({
  ...initialState,

  setApprovalsFilter: (filters: ApprovalsFilter) => {
    set(() => ({
      approvalsFilters: filters,
    }))
  },
})

export default createApprovalsSlice
